import React from "react";
import PropTypes from "prop-types";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";


import SignupOrSeparator from "../SignupOrSeparator";
import EmailSignUpForm from "./EmailSignUpForm";
import FacebookConnectButton from "../../../FacebookConnectButton/FacebookConnectButton";
import { intercomSendData, intercomTrackEvent } from "../../../utils/Intercom/intercomHelper";
//import InviterBox from "./InviterBox";

import style from "../../UserSessionForm.module"

export default class SignUpUserPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showEmailForm: true };

    this.handleShowEmailFormButtonClicked = this.handleShowEmailFormButtonClicked.bind(
      this
    );
    this.onSignUp = this.onSignUp.bind(this);
  }

  handleShowEmailFormButtonClicked(event) {
    event.preventDefault();

    this.setState({ showEmailForm: true });
  }

  renderShowEmailFormButton() {
    return (
      <a
        className="btn btn-block btn-primary sign-user-page--show-email-form-button"
        onClick={this.handleShowEmailFormButtonClicked}
      >
        {I18n.t("pages.user_session.links.register_with_email")}
      </a>
    );
  }

  renderFBConnectButton() {
    return (
      <Row>
        <Col xs={8} xsPush={2}>
          <FacebookConnectButton
            onLogin={this.onSignUp}
            title={I18n.t("register_facebook")}
          />
          <SignupOrSeparator />
        </Col>
      </Row>
    );
  }

  onSignUp(response) {
    intercomTrackEvent("Signup", {})
    intercomSendData({
      "TLT - Last Signup at": Date.now()
    })

    this.props.onLogin(response)
  }

  /*renderInviterBox() {
        const inviter = this.props.inviter;

        return inviter && inviter.id ? <InviterBox inviter={inviter}/> : '';
    }*/

  render() {
    return (
      <div className="sign-user-page">
        {/*<h2 className={"text-center"}>{I18n.t("register")}</h2>*/}

        {/*this.renderInviterBox()*/}

        {this.props.facebookConnectEnabled && this.renderFBConnectButton()}

        {this.state.showEmailForm ? (
          <EmailSignUpForm
            onLogin={this.onSignUp}
            inviter_referral_code={this.props.inviter_referral_code}
          />
        ) : (
          this.renderShowEmailFormButton()
        )}
        <hr />
        <div className={style.footerText}>
          {I18n.t("pages.user_session.links.already_registered")}{" "}

          <a href="#0" onClick={this.props.signInButtonClicked}>
            {I18n.t("sign_in")}
          </a>
        </div>
      </div>
    );
  }
}

SignUpUserPage.propTypes = {
  signInButtonClicked: PropTypes.func,
  onLogin: PropTypes.func,
  facebookConnectEnabled: PropTypes.bool
};
